import { Button } from '@rsos/components/capstone/base';
import styles from './RcsChat.module.scss';

const RcsEndChat = () => {
  return (
    <div
      className={styles.endChatContainer}
      data-name="end-chat-button-container"
    >
      <div className={styles.endChatInnerBox}>
        <Button btnType="warning_tertiary" disabled noMargin size="med" grow>
          End Chat
        </Button>
      </div>
    </div>
  );
};

export default RcsEndChat;
